import Vue from 'vue';
import PageBase from '@glittr/frontend-core/src/core/v2/app/pageBase';
import DataSource from '@glittr/frontend-core/src/core/v2/data/data-source';
import UploadRedebitsFileRequestModel from '../../../services/v2/model/upload-redebits-file-request-model';

export default class UploadRedebitPage extends PageBase {
  files: File[] = [];

  uploadSuccess: boolean = false;

  uploadDataSource = new DataSource({
    updateCommand: Vue.$service.v2.api.redebits.uploadRedebitsFile,
  });

  initialize(): Promise<void> {
    throw new Error('Method not implemented.');
  }

  async uploadFile() {
    if (this.files.length === 1) {
      const req = new UploadRedebitsFileRequestModel({ file: this.files[0] as File });
      try {
        await this.uploadDataSource.update(req);
        this.uploadSuccess = true;
      } catch (ex) {
        this.uploadDataSource.isLoading = false;
        this.uploadSuccess = false;
      } finally {
        this.files = [];
      }
    }
  }
}
